export default __webpack_public_path__ + "static/media/agordoj.4e76ea5c.svg";